var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveystreak1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 52,
    fill: "#302F2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Streak"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M-771 -24H634V954.1C634 977.793 614.793 997 591.1 997H-771V-24Z",
    fill: "#F7FBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 541",
    x: -742,
    y: -1,
    width: 1311,
    height: 138,
    rx: 21,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 565",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -26,
    width: 586,
    height: 312,
    rx: 30,
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    width: 55,
    height: 52,
    rx: 11,
    fill: "#FF9C00",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.0613 13.0001C17.2901 15.6411 26.7847 20.951 23.5243 22.8564C21.8726 23.8214 19.1916 23.6787 20.268 18.8196C14.8949 23.5584 16.4573 34.3555 22.6901 37.9174C21.3226 36.5145 20.4679 34.529 20.4679 32.3301C20.4679 28.0885 23.6472 24.6391 27.5564 24.6391C31.4659 24.6391 34.645 28.0886 34.645 32.3301C34.645 34.382 33.9011 36.2485 32.6904 37.6289C40.2804 33.4235 38.8802 21.8657 33.8236 18.9118C35.0303 21.9813 34.4054 24.3411 32.906 25.6569C33.6432 15.1813 23.0093 19.4026 26.0613 13.0001ZM27.5564 25.6601C24.1557 25.6601 21.4091 28.6404 21.4091 32.3301C21.4091 36.0199 24.1559 39 27.5564 39C30.957 39 33.7039 36.0199 33.7039 32.3301C33.7039 28.6405 30.9571 25.6602 27.5564 25.6602L27.5564 25.6601ZM27.5564 28.599C29.9226 28.599 31.8515 30.6918 31.8515 33.2591C31.8515 35.8263 29.9226 37.9174 27.5564 37.9174C25.1904 37.9174 23.263 35.8263 23.263 33.2591C23.263 30.6918 25.1904 28.5991 27.5564 28.5991L27.5564 28.599ZM27.5564 29.6201C25.699 29.6201 24.2042 31.2437 24.2042 33.2591C24.2042 35.2743 25.699 36.8962 27.5564 36.8962C29.4139 36.8962 30.9103 35.2744 30.9103 33.2591C30.9103 31.2438 29.4139 29.6201 27.5564 29.6201H27.5564ZM27.5564 30.6396C28.8885 30.6396 29.9676 31.8121 29.9676 33.2573C29.9676 34.7026 28.8885 35.8734 27.5564 35.8734C26.2245 35.8734 25.1438 34.7026 25.1438 33.2573C25.1438 32.7978 25.2541 32.3658 25.446 31.9903C25.5386 32.6643 26.0738 33.1822 26.7208 33.1822C27.4329 33.1822 28.0098 32.5546 28.0098 31.782C28.0098 31.311 27.7957 30.8948 27.4668 30.6413C27.4966 30.6401 27.5265 30.6396 27.5565 30.6396H27.5564Z",
    fill: "#FF7A00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -134.4,
    y: -138.4,
    width: 818.8,
    height: 544.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 32,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveystreak1);
export default __webpack_public_path__ + "static/media/Surveystreak1.b5b72710685b09bb8f9ff4bb648b3eb8.svg";
export { ForwardRef as ReactComponent };